export default __webpack_public_path__ + "static/media/glasgow.ed48a86c.jpg";